import api from "!../../../checkout/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../checkout/node_modules/css-loader/dist/cjs.js??clonedRuleSet-19.use[1]!../../../checkout/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../checkout/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-19.use[2]!../../../checkout/node_modules/less-loader/dist/cjs.js!../../../checkout/node_modules/vue-loader/lib/index.js??vue-loader-options!./AlternativeItemSelector.vue?vue&type=style&index=0&id=026189ea&prod&scoped=true&lang=less";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};